import React, { useState, useEffect } from 'react';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import GameInfocont from '@/pages/intelligence/components/TableComponents/components/GameInfocont';
import Appannie from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import SensorTower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import { Progress } from 'tea-component';
import { formatP } from '@/pages/intelligence/pages/MarketProfile/_util';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { history, useIntl } from 'umi';
import { DataSourceBubbleContent } from '@/pages/intelligence/components/DataSourceBubbleContent';
import mscience32 from '@/pages/intelligence/assets/svg/marketprofile/mscience32.svg';
import xbox from '@/pages/intelligence/assets/svg/marketprofile/xbox.svg';
import playstation from '@/pages/intelligence/assets/svg/marketprofile/playstation.svg';
import nintendo from '@/pages/intelligence/assets/svg/marketprofile/nintendo.svg';

export const sourceKeyMap = {
  appannie: {
    metric: 'appannie',
    icon: Appannie,
  },
  sensortower: {
    metric: 'sensortower',
    icon: SensorTower,
  },
  mscience: {
    metric: 'mscience',
    icon: mscience32,
  },
};

export default function Columns({
  id,
  mainSegment,
  source,
}: {
  id: string;
  mainSegment?: string;
  source?: string;
}) {
  const { formatMessage } = useIntl();
  // 跳转到游戏详情
  const gotoGameDetailsPage = (val: any, gameType: string, jump = true) => {
    const path = getDetailGamePathCommon({
      entityType: gameType,
      gameId: val.id,
      tab: 'overview',
    });
    if (jump) {
      buriedBtnPoint(dbiBtnLogMes.marketProfileOverviewClickGame);
      return history.push(path);
    }
    return path;
  };

  // 跳转到公司详情
  const gotoCompanyDetailsPage = (val: any, jump = true) => {
    const sta = {
      app_id: val.id,
      name: val.name,
    };
    const path = `/intelligence/topCharts/companies/gamesDetails/${val.id}/Summary`;
    if (jump) {
      buriedBtnPoint(dbiBtnLogMes.marketProfileOverviewClickGame);
      return history.push({
        pathname: path,
        state: sta,
      });
    }
    return path;
  };

  const allColumns = {
    mpTopGameListChartTotalMobile:
      mainSegment === 'active'
        ? [
            {
              key: 'Top Game',
              header: formatMessage({ id: 'dbi_market_top_game' }),
              align: 'left',
              width: 230,
              render: (cvm: any) => {
                return (
                  <GameInfocont
                    data={cvm.list}
                    type={'mobile'}
                    rank={cvm.rank}
                    onClick={() => gotoGameDetailsPage(cvm, 'mobile')}
                    rightClickToJumpHref={gotoGameDetailsPage(cvm, 'mobile', false)}
                  />
                );
              },
            },
            {
              key: 'Revenue($)',
              align: 'right',
              width: 160,
              header: (
                <SortBy
                  title={formatMessage({ id: 'dbi_mau' })}
                  content={formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
                  // svgIcon={Appannie}
                  svgIcon={sourceKeyMap?.[source]?.icon || Appannie}
                  isNoDropdown={true}
                  svgTip={
                    <DataSourceBubbleContent
                      sourceNameLocalId={formatMessage({ id: 'dbi_revenue_$' })}
                      // metric={'appannie'}
                      metric={sourceKeyMap?.[source]?.metric || 'appannie'}
                      metricKey={'mau'}
                    />
                  }
                />
              ),
              render: (cvm: any) => {
                return (
                  <TableShowData
                    value={formatNum(cvm.revenue, true)}
                    type={cvm.precentChange == 0 ? '-' : cvm.precentChange > 0 ? 'up' : 'down'}
                    growth={cvm.precentChange == 0 ? '-' : formatPercentNum(cvm.precentChange)}
                    cvm={cvm.dau}
                  />
                );
              },
            },
          ]
        : [
            {
              key: 'Top Game',
              header: formatMessage({ id: 'dbi_market_top_game' }),
              align: 'left',
              width: 230,
              render: (cvm: any) => {
                return (
                  <GameInfocont
                    data={cvm.list}
                    type={'mobile'}
                    rank={cvm.rank}
                    onClick={() => gotoGameDetailsPage(cvm, 'mobile')}
                    rightClickToJumpHref={gotoGameDetailsPage(cvm, 'mobile', false)}
                  />
                );
              },
            },
            {
              key: 'Revenue($)',
              align: 'right',
              width: 160,
              header: (
                <SortBy
                  title={formatMessage({
                    id: mainSegment === 'downloads' ? 'dbi_downloads' : 'dbi_revenue_$',
                  })}
                  content={formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
                  // svgIcon={Appannie}
                  svgIcon={sourceKeyMap?.[source]?.icon || Appannie}
                  isNoDropdown={true}
                  svgTip={
                    <DataSourceBubbleContent
                      sourceNameLocalId={formatMessage({ id: 'dbi_revenue_$' })}
                      // metric={'appannie'}
                      metric={sourceKeyMap?.[source]?.metric || 'appannie'}
                      metricKey={mainSegment}
                      entityType="mobile"
                    />
                  }
                />
              ),
              render: (cvm: any) => {
                return (
                  <TableShowData
                    value={formatNum(cvm.revenue, true)}
                    type={cvm.precentChange == 0 ? '-' : cvm.precentChange > 0 ? 'up' : 'down'}
                    growth={cvm.precentChange == 0 ? '-' : formatPercentNum(cvm.precentChange)}
                    cvm={cvm.dau}
                  />
                );
              },
            },
            {
              key: '% of Market',
              header: formatMessage({ id: 'dbi_market_percent' }),
              align: 'right',
              width: 130,
              render: (cvm: any) => {
                return (
                  <Progress
                    className="tabdetails-progress"
                    type="circle"
                    percent={formatP(cvm.precent)}
                    strokeWidth={8}
                    strokeColor="#376AE7"
                  />
                );
              },
            },
          ],
    mpTopGameListChartTotalPc: [
      {
        key: 'Top Game',
        header: formatMessage({ id: 'dbi_market_top_game' }),
        align: 'left',
        width: 230,
        render: (cvm: any) => {
          return (
            <GameInfocont
              data={cvm.list}
              type={'pc'}
              rank={cvm.rank}
              onClick={() => gotoGameDetailsPage(cvm, 'pc')}
              rightClickToJumpHref={gotoGameDetailsPage(cvm, 'pc', false)}
            />
          );
        },
      },
      {
        key: 'Revenue($)',
        align: 'right',
        width: 160,
        header: (
          <SortBy
            title={formatMessage({ id: 'dbi_revenue_$' })}
            svgIcon={mscience32}
            isNoDropdown={true}
            svgTip={
              <DataSourceBubbleContent
                sourceNameLocalId={formatMessage({ id: 'dbi_revenue_$' })}
                metric={'mscience'}
                metricKey={'digitalRevenue'}
                entityType="pc"
              />
            }
          />
        ),
        render: (cvm: any) => {
          return (
            <TableShowData
              value={formatNum(cvm.revenue, true)}
              type={cvm.precentChange == 0 ? '-' : cvm.precentChange > 0 ? 'up' : 'down'}
              growth={cvm.precentChange == 0 ? '-' : formatPercentNum(cvm.precentChange)}
              cvm={cvm.dau}
            />
          );
        },
      },
      {
        key: '% of Market',
        header: formatMessage({ id: 'dbi_market_percent' }),
        align: 'right',
        width: 130,
        render: (cvm: any) => {
          return (
            <Progress
              className="tabdetails-progress"
              type="circle"
              percent={formatP(cvm.precent)}
              strokeWidth={8}
              strokeColor="#376AE7"
            />
          );
        },
      },
    ],
    mpTopGameListChartTotalConsole: [
      {
        key: 'Top Game',
        header: formatMessage({ id: 'dbi_market_top_game' }),
        align: 'left',
        width: 230,
        render: (cvm: any) => {
          return (
            <GameInfocont
              data={cvm.list}
              type={'console'}
              rank={cvm.rank}
              iconList={cvm.platList.map((obj: any) => {
                if (obj.toUpperCase() == 'PS') return playstation;
                if (obj.toUpperCase() == 'XBOX') return xbox;
                if (obj.toUpperCase() == 'NINTENDO') return nintendo;

                return '';
              })}
              onClick={() => gotoGameDetailsPage(cvm, 'console')}
              rightClickToJumpHref={gotoGameDetailsPage(cvm, 'console', false)}
            />
          );
        },
      },
      {
        key: 'Revenue($)',
        align: 'right',
        width: 160,
        header: (
          <SortBy
            title={formatMessage({ id: 'dbi_revenue_$' })}
            svgIcon={mscience32}
            isNoDropdown={true}
            svgTip={
              <DataSourceBubbleContent
                sourceNameLocalId={formatMessage({ id: 'dbi_revenue_$' })}
                metric={'mscience'}
                metricKey={'digitalRevenue'}
                entityType="console"
              />
            }
          />
        ),
        render: (cvm: any) => {
          return (
            <TableShowData
              value={formatNum(cvm.revenue, true)}
              type={cvm.precentChange == 0 ? '-' : cvm.precentChange > 0 ? 'up' : 'down'}
              growth={cvm.precentChange == 0 ? '-' : formatPercentNum(cvm.precentChange)}
              cvm={cvm.dau}
            />
          );
        },
      },
      {
        key: '% of Market',
        header: formatMessage({ id: 'dbi_market_percent' }),
        align: 'right',
        width: 130,
        render: (cvm: any) => {
          return (
            <Progress
              className="tabdetails-progress"
              type="circle"
              percent={formatP(cvm.precent)}
              strokeWidth={8}
              strokeColor="#376AE7"
            />
          );
        },
      },
    ],
    mpTopGameListChartTotalCompany: [
      {
        key: 'Top Game',
        header: formatMessage({ id: 'dbi_market_top_company' }),
        align: 'left',
        width: 230,
        render: (cvm: any) => {
          cvm.list.text = cvm.conutryName;
          return (
            <GameInfocont
              data={cvm.list}
              type="company"
              rank={cvm.rank}
              onClick={() => gotoCompanyDetailsPage(cvm)}
              rightClickToJumpHref={gotoCompanyDetailsPage(cvm, false)}
            />
          );
        },
      },
      {
        key: 'Sum Revenue($)',
        align: 'right',
        width: 160,
        header: (
          <SortBy
            title={formatMessage({ id: 'dbi_company_metrics_sum_revenue' })}
            isNoDropdown={true}
            content={formatMessage({ id: 'dbi_company_tables_info_tips1' })}
          />
        ),
        render: (cvm: any) => {
          return (
            <TableShowData
              value={formatNum(cvm.revenue, true)}
              type={cvm.precentChange == 0 ? '-' : cvm.precentChange > 0 ? 'up' : 'down'}
              growth={cvm.precentChange == 0 ? '-' : formatPercentNum(cvm.precentChange)}
              cvm={cvm.dau}
            />
          );
        },
      },
      {
        key: '% of Market',
        header: formatMessage({ id: 'dbi_market_percent' }),
        align: 'right',
        width: 130,
        render: (cvm: any) => {
          return (
            <Progress
              className="tabdetails-progress"
              type="circle"
              percent={formatP(cvm.precent)}
              strokeWidth={8}
              strokeColor="#376AE7"
            />
          );
        },
      },
    ],
    mpTopGameListChartGameCompany: [
      {
        key: 'Top Game',
        header: formatMessage({ id: 'dbi_market_top_company' }),
        align: 'left',
        width: 230,
        render: (cvm: any) => {
          cvm.list.text = cvm.conutryName;
          return (
            <GameInfocont
              data={cvm.list}
              type="company"
              rank={cvm.rank}
              onClick={() => gotoCompanyDetailsPage(cvm)}
              rightClickToJumpHref={gotoCompanyDetailsPage(cvm, false)}
            />
          );
        },
      },
      {
        key: 'Sum Revenue($)',
        align: 'right',
        width: 160,
        header: (
          <SortBy
            title={formatMessage({
              id:
                mainSegment === 'downloads'
                  ? 'dbi_calc_metric_sum_downloads'
                  : 'dbi_company_metrics_sum_revenue',
            })}
            isNoDropdown={true}
            content={formatMessage({ id: 'dbi_company_tables_info_tips1' })}
          />
        ),
        render: (cvm: any) => {
          return (
            <TableShowData
              value={formatNum(cvm.revenue, true)}
              type={cvm.precentChange == 0 ? '-' : cvm.precentChange > 0 ? 'up' : 'down'}
              growth={cvm.precentChange == 0 ? '-' : formatPercentNum(cvm.precentChange)}
              cvm={cvm.dau}
            />
          );
        },
      },
      {
        key: '% of Market',
        header: formatMessage({ id: 'dbi_market_percent' }),
        align: 'right',
        width: 130,
        render: (cvm: any) => {
          return (
            <Progress
              className="tabdetails-progress"
              type="circle"
              percent={formatP(cvm.precent)}
              strokeWidth={8}
              strokeColor="#376AE7"
            />
          );
        },
      },
    ],
  } as any;
  return allColumns[id];
}
